<script setup lang="ts">
import type { ModelRef } from 'vue';
import type { Props } from '@/components/forms/input/types';
import TopInput from '@/components/forms/input/input.vue';

withDefaults(defineProps<Props>(), {
	addCleaner: true,
});

const model: ModelRef<string> = defineModel({
	default: '',
});
</script>

<template>
	<TopInput
		:="$props"
		modificator="popupWidgetInput"
		v-model="model"
	/>
</template>

<style>
.top-input-popupWidgetInput {
	--top-loadbar-color: var(--color-line-2);

	width: 100%;
}

.top-input_input-popupWidgetInput {
	border: none;
	background: var(--color-layer-1);
}

.top-input_input-popupWidgetInput:hover {
	background: var(--color-layer-2);
}

.top-input_input-popupWidgetInput:focus {
	background: var(--color-layer-1);
	outline: unset;
}
</style>
